<template>
    <el-card>
        <div slot="header">
            <span class="top_title">采购单详细</span>
        </div>
        <div class="searchItem">
            <div class="search">
                <span class="searchtips">日期:</span>
                <el-date-picker
                    v-model="searchDate.dateRan"
                    type="daterange"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 230px"
                    :editable="false"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </div>
            <div class="search">
                <span class="searchtips">采购单号:</span>
                <el-input v-model="searchDate.purid" placeholder="" style="width: 160px;" clearable></el-input>
            </div>
            <div class="search">
                <span class="searchtips">供应商:</span>
                <el-select v-model="searchDate.slid" clearable style="width:160px">
                    <el-option v-for="item in supplyList" :key="item.id" :value="item.id" :label="item.label"></el-option>
                </el-select>
            </div>
            <div class="search">
                <span class="searchtips">类型:</span>
                <el-select v-model="searchDate.type" clearable style="width:160px">
                    <el-option value="1" label="采购单"></el-option>
                    <el-option value="2" label="退货单"></el-option>
                </el-select>
            </div>
            <div class="search">
                <span class="searchtips">备注:</span>
                <el-input v-model="searchDate.remark" placeholder="" style="width: 160px;" clearable></el-input>
            </div>
            <div class="search">
                <el-button type="primary" icon="el-icon-search" @click="searchOrder()">查询</el-button>
            </div>
        </div>
        <el-table
            :data="tableData"
            style="
                width: 100%;
                margin-top: 20px;
                margin-bottom: 20px;
            "
            border
            show-summary
            :summary-method="getSummaries"
        >
            <el-table-column label="操作" align="center" width="100px">
                <template slot-scope="prop">
                    <div v-if="prop.row.type==1">
                        <el-button type="text" @click="edit(prop.row)" v-if="$common.hasLimits('materialOrderDetailEdit')">编辑</el-button>
                        <el-button type="text" @click="del(prop.row.modid)" v-if="$common.hasLimits('materialOrderDetailDelete')">删除</el-button>
                    </div>
                    <div v-else>
                        <el-button type="text" @click="edit(prop.row)" v-if="$common.hasLimits('materialReturnDetailEdit')">编辑</el-button>
                        <el-button type="text" @click="del(prop.row.modid)" v-if="$common.hasLimits('materialReturnDetailDelete')">删除</el-button>
                    </div>
                </template>
            </el-table-column>
            <template v-for="(col, index) in cols">
				<el-table-column 
					:key="index"
					:prop="col.prop" 
					:label="col.label" 
					:width="col.width"
					:min-width="col.min_width"
					align="left"
				>
					<template #header v-if="col.column">
						{{col.label}}
						<el-button circle icon="el-icon-top" size="mini" v-if="searchDate.column==col.column&&searchDate.order==true" type="primary" @click="setSort(col.column,true)"></el-button>
						<el-button circle icon="el-icon-top" size="mini" v-else @click="setSort(col.column,true)"></el-button>
						<el-button circle icon="el-icon-bottom" size="mini" v-if="searchDate.column==col.column&&searchDate.order==false" type="primary" @click="setSort(col.column,false)"></el-button>
						<el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort(col.column,false)"></el-button>
					</template>
					<template slot-scope="{ row }">
						<template v-if="col.type=='pType'">
							<template>
                                <div>{{row.type==1?row.present:'-'}}</div>
                            </template>
						</template>
						<template v-else-if="col.type=='pmType'">
							<template>
                                <div>{{row.type==1?row.presentMoney:'-'}}</div>
                            </template>
						</template>
                        <template v-else-if="col.type=='completeType'">
							<template>
                                <div>{{row.type==1?row.complete:'-'}}</div>
                            </template>
						</template>
						<template v-else>
							<div>{{row[col.prop]}}</div>
						</template>
					</template>
				</el-table-column>
			</template>
        </el-table>
        <el-pagination
            style="text-align: right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 50, 120, 250]"
            :page-size="cp_pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :pager-count="5"
        >
        </el-pagination>
        <el-dialog title="编辑" :visible.sync="editDialog" width="60%">
            <div style="display:flex;line-height:40px" v-if="editRow.inter==1">
                <div style="width:100px;margin-bottom:10px">数量:</div>
                <el-input v-model="editValue.amount" @input="$common.checkNumber($event,editValue,'amount')" style="width:180px"></el-input>
            </div>
            <div style="display:flex;line-height:40px" v-else>
                <div style="width:100px;margin-bottom:10px">数量:</div>
                <el-input v-model="editValue.amount" @input="$common.checkMoney($event,editValue,'amount')" style="width:180px"></el-input>
            </div>
            <div style="display:flex;line-height:40px">
                <div style="width:100px;margin-bottom:10px">开单单价:</div>
                <el-input v-model="editValue.price" @input="$common.checkMoney($event,editValue,'price')" style="width:180px"></el-input>
            </div>
            <div style="display:flex;line-height:40px" v-if="editRow.type==1">
                <div style="width:100px">现金单价:</div>
                <el-input v-model="editValue.present" @input="$common.checkMoney($event,editValue,'present')" style="width:180px"></el-input>
            </div>
            <div class="rootbtn">
                <el-button type="primary" @click="saveSend()">确认</el-button>
                <el-button @click="editDialog = false">取消</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
export default {
    components:{
    },
    data(){
        return{
            searchDate: {
                dateRan: "",
                purid:"",
                slid:"",
                remark:'',
                type:"1",
                column:'',
				order:'',
            },
            pickerOptions: {shortcuts:this.$common.initPickerOptions()},
            tableData:[],
            supplyList:[],
            total:0,
            currentPage:1,
            cp_pagesize:20,
            nowSearch:{
                limit:20,
                page:1,
                type:"1",
            },
            amountSum:0,
            moneySum:0,
            completeSum:0,
            presentMoneySum:0,
            editDialog:false,
            editValue:{
                amount:0,
                price:0,
                present:0,
            },
            editRow:{},
            cols:[
                {
                    label:'采购单号',
                    prop:'number',
                    width:'180',
                    column:'number',
                },{
                    label:'产品',
                    prop:'mname',
                    min_width:'180',
                    column:'mnumber',
                },{
                    label:'属性1',
                    prop:'mspec1',
                },{
                    label:'属性2',
                    prop:'mspec2',
                },{
                    label:'数量',
                    prop:'amount',
                    column:'amount',
                    width:'180',
                },{
                    label:'开单单价',
                    prop:'price',
                    column:'price',
                    width:'180',
                },{
                    label:'总金额',
                    prop:'money',
                    column:'money',
                    width:'180',
                },{
                    label:'现金单价',
                    prop:'',
                    type:'pType',
                    column:'present',
                    width:'180',
                },{
                    label:'现金总价',
                    prop:'',
                    type:'pmType',
                    column:'presentMoney',
                    width:'180',
                },{
                    label:'已入库',
                    prop:'',
                    type:'completeType',
                    column:'complete',
                    width:'180',
                },{
                    label:'备注',
                    prop:'remark',
                    width:'180',
                },{
                    label:'创建日期',
                    prop:'cdate',
                    column:'cdate',
                    width:'180',
                }
            ]
        }
    },
    created(){
        this.$api.listSupply().then(res=>{
            if(res.data.code==1){
                res.data.data.data.forEach(e => {
                    let obj = {
                        id:e.id,
                        label:"["+e.number+"]"+e.name,
                    }
                    this.supplyList.push(obj);
                });
            }
        })
        this.getInfo();
    },
    methods: {
        getSummaries() {
            return ['合计',,,,,this.amountSum,,this.moneySum,,this.presentMoneySum,this.completeSum];
        },
        setSort(column,order){
            if(this.searchDate.column==column&&this.searchDate.order==order){
                this.searchDate.column = '';
                this.searchDate.order = '';
            }else{
                this.searchDate.column = column;
                this.searchDate.order = order;
            }
            this.sortTime();
        },
        sortTime(){
            if(this.searchDate.column){
                this.nowSearch.column = this.searchDate.column;
                this.nowSearch.order = this.searchDate.order?'asc':'desc';
            }else{
                delete this.nowSearch.column;
                delete this.nowSearch.order;
            }
            this.getInfo();
        },
        searchOrder(){
            this.currentPage = 1;
            this.nowSearch = {
                limit:this.cp_pagesize,
                page:1,
            }
            if(this.searchDate.dateRan&&this.searchDate.dateRan.length>=2){
                this.nowSearch.start = this.searchDate.dateRan[0];
                this.nowSearch.end = this.searchDate.dateRan[1];
            }
            if(this.searchDate.purid.length>0){
                this.nowSearch.number = this.searchDate.purid;
            }
            if(this.searchDate.slid>0){
                this.nowSearch.supply = this.searchDate.slid;
            }
            if(this.searchDate.type>0){
                this.nowSearch.type = this.searchDate.type;
            }
            if(this.searchDate.remark.length>0){
                this.nowSearch.remark = this.searchDate.remark;
            }
            this.sortTime();
        },
        getInfo(){
            this.$api.getInfoPostSingle('/material/order/listDetail',this.nowSearch).then(res=>{
                if(res.data.code==1){
                    this.tableData = res.data.data.data;
                    this.total = res.data.data.total;
                    this.amountSum = res.data.data.amountSum;
                    this.moneySum = res.data.data.moneySum;
                    this.completeSum = res.data.data.completeSum;
                    this.presentMoneySum = res.data.data.presentMoneySum;
                }
            })
        },
        handleSizeChange(e){
            this.cp_pagesize = e;
            this.searchOrder();
        },
        handleCurrentChange(e){
            this.currentPage = e;
            this.nowSearch.page = e;
            this.getInfo();
        },
        edit(row){
            this.editRow = row;
            this.editValue.amount = row.amount;
            this.editValue.price = row.price;
            this.editValue.present = row.present;
            this.editDialog = true;
        },
        saveSend(row){
            this.editValue.id = this.editRow.modid;
            this.$api.getInfoPostSingle('material/order/editOrderDetil',this.editValue).then(res=>{
                if(res.data.code==1){
                    this.$notify({
                        title: "编辑数据",
                        message: "编辑成功",
                        type: "success",
                        duration: 1000,
                    });
                    delete this.editValue.id;
                    this.editDialog = false;
                    this.editRow = {};
                    this.getInfo();
                }
            })
        },
        del(id){
            if(!id){
                return;
            }
            this.$api.getInfoPostSingle("material/order/deleteDetail",{deleteId:id}).then(res=>{
                if(res.data.code==1){
                    if(this.tableData.length==1&&this.currentPage>1){
                        this.currentPage = 1;
                    }
                    this.$notify({
                        title: "删除数据",
                        message: "删除成功",
                        type: "success",
                        duration: 1000,
                    });
                    this.getInfo();
                }
            })
        },
    }
}
</script>